const util = require('util');
Object.defineProperty(util, '_extend', {
    value: Object.assign,
    writable: true,
    enumerable: true,
    configurable: true
});

require('dotenv').config({ quiet: true });

const createServer = require('./server');
const router = require('./router');
const setupDatabase = require('./lib/database');
const setupMiddlewares = require('./lib/middlewares');
const setupWebsocket = require('./lib/websocket');
const FullstxApplication = require('./lib/application');

let faker;
try {
    faker = require('@faker-js/faker').faker;
} catch {}

let sanitizeHtml;
try {
    sanitizeHtml = require('sanitize-html');
} catch {}

let Sentry;
try {
    Sentry = require('@sentry/node');
} catch {}

function Framework(options = {}) {
    const defaults = {
        logger: true,
        cors: true,
        helmet: true,
        xss: true,
        compression: true,
        session: false,
        htmx: true,
        staticDir: 'public',
        liveReload: true,
        port: 3000,
        jwtSecret: process.env.JWT_SECRET || 'supersecret',
        healthCheck: true,
        internalPort: undefined,
        db: null,
        ws: null,
        sqlite: null,
        sentry: null
    };

    const opts = Object.assign({ ...defaults }, options);

    if (opts.sentry && Sentry) {
        Sentry.init(opts.sentry);
        global.sentryCapture = Sentry.captureException;
        console.log('[fullstx] Sentry Error Tracking enabled.');
    }

    const ws = setupWebsocket(opts, {});
    const db = setupDatabase(opts, router);

    setupMiddlewares(opts, router, sanitizeHtml);

    const server = createServer(router, router.middlewares, {
        staticDir: opts.staticDir
    });

    const app = new FullstxApplication(
        opts,
        router,
        db,
        ws.wsRedisPub,
        ws.wsRedisSub,
        null,
        Sentry,
        faker,
        sanitizeHtml,
        server
    );

    if (ws.wsRedisSub) {
        const channel = opts.ws.pubSubChannel || 'fullstx_ws_pubsub';
        ws.wsRedisSub.subscribe(channel, (message) => {
            if (app.wss) {
                app.wss.clients.forEach((client) => {
                    if (client.readyState === 1) client.send(message);
                });
            }
        });
    }

    return app;
}

module.exports = Framework;
